import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyLabelComponent } from './label.component';


export class SkyLabelModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyLabelComponent
  ],
  imports: [CommonModule],
  exports: [
    SkyLabelComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
